import React, { createContext, useContext, useEffect, useState } from "react";

const GlobalContext = createContext(undefined);

export const GlobalContextProvider = ({ children }) => {
  const [favoriteCount, setFavoriteCount] = useState(0);

  // will be used to make the sarch bar possible
  const [allProductsReference, setAllProductsReference] = useState([]);

  useEffect(() => {
    if (!window) return;
    updateFavoriteCount();
  }, []);

  const updateFavoriteCount = () => {
    const favorites = JSON.parse(localStorage.getItem("Favorite") ?? "[]");
    setFavoriteCount(favorites.length);
  };

  return (
    <GlobalContext.Provider
      value={{
        favoriteCount,
        setFavoriteCount,
        updateFavoriteCount,
        setAllProductsReference,
        allProductsReference,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error(
      "useGlobalContext must be used within a GlobalContextProvider",
    );
  }
  return context;
};
